import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Remove legacy PostHog browser storage left over from earlier builds (no analytics are used anymore).
try {
  [localStorage, sessionStorage].forEach(st => Object.keys(st).filter(k => k.startsWith("ph_") || k.includes("posthog")).forEach(k => st.removeItem(k)));
  document.cookie.split(";").map(c => c.trim().split("=")[0]).filter(n => n.startsWith("ph_") || n.includes("posthog")).forEach(n => {
    [location.hostname, "." + location.hostname, "." + location.hostname.split(".").slice(-2).join(".")].forEach(d => { document.cookie = `${n}=; Max-Age=0; path=/; domain=${d}`; });
    document.cookie = `${n}=; Max-Age=0; path=/`;
  });
} catch (e) { /* storage unavailable */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
